{
  "types": {
    "percentage": "ลด %",
    "fixed": "ลดเป็นเงินเยน",
    "free_shipping": "ส่งฟรี",
    "bxgy": "ซื้อหลายชิ้น แถม 1 ชิ้น"
  },
  "types_help": {
    "percentage": "เช่น ลดการ์ด 10%",
    "fixed": "เช่น ลด 500 เยนจากออเดอร์",
    "free_shipping": "ลูกค้าไม่ต้องจ่ายค่าส่ง",
    "later": "จะมีภายหลัง"
  },
  "value": {
    "percent": "ลด {{percent}}%",
    "amount": "ลด {{amount}}"
  },
  "channels": {
    "web": "เว็บไซต์",
    "pos": "หน้าร้าน"
  },
  "state": {
    "active": "ใช้ได้",
    "scheduled": "ยังไม่เริ่ม",
    "expired": "หมดอายุ",
    "used_up": "ใช้ครบแล้ว",
    "inactive": "ปิดอยู่"
  },
  "columns": {
    "code": "โค้ด",
    "value": "ส่วนลด",
    "channels": "ใช้ที่",
    "period": "ช่วงเวลา",
    "used": "ใช้ไป",
    "state": "สถานะ"
  },
  "period": {
    "now": "ตอนนี้",
    "no_end": "ไม่มีวันจบ",
    "always": "ตลอด"
  },
  "used": {
    "of": "{{used}} จาก {{limit}}",
    "count_other": "{{count}} ครั้ง"
  },
  "filters": {
    "q": "ค้นหา",
    "q_placeholder": "โค้ดหรือชื่อ",
    "active": "เปิดอยู่",
    "type": "ประเภท"
  },
  "list": {
    "intro": "โค้ดที่ลูกค้าพิมพ์ตอนจ่ายเงินหรือบอกที่เคาน์เตอร์ ของฝากขายลดได้เฉพาะที่ผู้ฝากอนุญาต (ไม่เกิน 10%)",
    "create": "โค้ดใหม่"
  },
  "usage": {
    "title": "ออเดอร์ที่ใช้",
    "count": "ใช้ไป",
    "total": "ส่วนลดรวม:",
    "none": "ยังไม่มีการใช้"
  },
  "locales": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh_Hant": "繁體中文",
    "zh_Hans": "简体中文"
  },
  "product_types": {
    "raw_single": "การ์ดเดี่ยว",
    "graded_single": "การ์ดเกรด",
    "sealed_product": "กล่อง/ซองยังไม่แกะ"
  },
  "problems": {
    "code": "ตัวอักษรหรือตัวเลข (และ - _) 3–64 ตัว ขึ้นต้นด้วยตัวอักษรหรือตัวเลข",
    "percent": "ใส่เปอร์เซ็นต์ระหว่าง 0 ถึง 100",
    "amount": "ใส่ยอดเป็นเยนเต็มจำนวน",
    "collections": "เลือกอย่างน้อย 1 คอลเลกชัน",
    "types": "เลือกประเภทสินค้าอย่างน้อย 1 อย่าง",
    "channels": "เลือกเว็บไซต์ หน้าร้าน หรือทั้งสอง",
    "count": "ตัวเลขเต็มจำนวน หรือเว้นว่างถ้าไม่จำกัด",
    "period": "วันจบต้องหลังวันเริ่ม",
    "fix_other": "แก้ {{count}} ช่องก่อน"
  },
  "form": {
    "load_failed": "เปิดโค้ดไม่ได้",
    "back": "โค้ดทั้งหมด",
    "new_title": "โค้ดส่วนลดใหม่",
    "tabs": "โค้ด",
    "tab_settings": "ตั้งค่า",
    "tab_usage_other": "ใช้ไป ({{count}})",
    "kind": "ส่วนลดแบบไหน?",
    "code_block": "โค้ดและชื่อ",
    "code": "โค้ดที่ลูกค้าพิมพ์",
    "code_hint": "ตัวพิมพ์ใหญ่และตัวเลข เช่น WEEKEND10",
    "suggest": "สร้างให้",
    "code_locked": "โค้ดนี้ถูกใช้แล้ว — เปลี่ยนชื่อไม่ได้",
    "titles": "ชื่อที่ลูกค้าเห็น (ไม่บังคับ)",
    "how_much": "ลดเท่าไร?",
    "percent": "ลดกี่เปอร์เซ็นต์",
    "amount": "ลดกี่เยน",
    "shipping_where": "ส่งฟรีไปที่",
    "shipping": {
      "everywhere": "ทุกประเทศ",
      "japan": "เฉพาะญี่ปุ่น"
    },
    "applies": "ใช้กับ",
    "applies_to": {
      "all": "ทั้งร้าน",
      "collections": "บางคอลเลกชัน",
      "types": "บางประเภทสินค้า"
    },
    "collections_search": "ค้นหาคอลเลกชัน",
    "collections_none": "ไม่พบคอลเลกชัน",
    "collection_count_other": "{{count}} สินค้า",
    "conditions": "เงื่อนไข",
    "channels": "ใช้ได้ที่",
    "min_subtotal": "ยอดสั่งขั้นต่ำ",
    "min_subtotal_hint": "เว้นว่าง = ไม่มีขั้นต่ำ",
    "usageLimit": "ใช้ได้กี่ครั้งรวม",
    "perCustomerLimit": "ใช้ได้กี่ครั้งต่อคน",
    "limit_hint": "เว้นว่าง = ไม่จำกัด",
    "groups_later": "โค้ดสำหรับกลุ่มลูกค้าจะมีภายหลัง",
    "when": "ช่วงเวลา",
    "this_weekend": "สุดสัปดาห์นี้",
    "startsAt": "เริ่ม",
    "endsAt": "ถึง",
    "jst": "เวลาญี่ปุ่น",
    "consigned": "ของฝากขาย",
    "respects": "ทำตามที่ผู้ฝากเลือก",
    "respects_help": "ของฝากขายลดได้เฉพาะที่ผู้ฝากอนุญาต และไม่เกิน {{max}}%",
    "warning": {
      "over_limit": "{{percent}}% มากกว่า {{max}}%: ของฝากขายลดได้ไม่เกิน {{max}}% (เฉพาะที่ผู้ฝากอนุญาต) — ของร้านลด {{percent}}%",
      "ignores_consignor": "ของฝากขายจะถูกลดราคาโดยไม่ถามผู้ฝาก ทำเฉพาะเมื่อผู้ฝากทุกคนตกลงแล้ว"
    },
    "active": "เปิดใช้ (ลูกค้าใช้ได้)",
    "save": "บันทึกการแก้ไข",
    "create": "สร้างโค้ด",
    "read_only": "เฉพาะเจ้าของหรือผู้จัดการที่แก้โค้ดได้",
    "saved": "บันทึก {{code}} แล้ว",
    "created": "{{code}} พร้อมใช้",
    "stale": "มีคนเพิ่งแก้โค้ดนี้ เปิดใหม่อีกครั้ง",
    "switch_off": "ปิด",
    "switch_on": "เปิด",
    "switched_off": "ปิด {{code}} แล้ว",
    "switched_on": "เปิด {{code}} แล้ว",
    "delete": "ลบ",
    "delete_title": "ลบ {{code}}?",
    "delete_consequence": "โค้ดจะหายไป ลูกค้าใช้ไม่ได้อีก",
    "delete_used": "โค้ดนี้ถูกใช้แล้ว — จะเก็บไว้ในประวัติ ให้ปิดแทน",
    "deleted": "ลบ {{code}} แล้ว",
    "in_use": "โค้ดนี้ถูกใช้แล้ว — ให้ปิดแทน"
  }
}
